import React from "react";
import {connect} from "react-redux";
import {
    getClientLogoData,
} from "../../../../redux/selectors/newsletters";


/**
 * ouptut the client logo image if any
 * @param  {} props
 * @return {}
 */
const ClientLogo = (props) => {
    const {logoSrc, logoAlt} = props.clientLogoData;

    if (logoSrc !== "") {
        return (
            <div className="mb-3 client-logo">
                <img src={logoSrc} alt={`${logoAlt} logo`} />
            </div>
        )
    } else {
        return null;
    }
};

/**
 * mapStateToProps returns the parts of the state that will be available as props
 * @param state
 * @returns {}
 */
const mapStateToProps = state => {
    return {
        clientLogoData: getClientLogoData(state),
    };
};

/**
 * mapDispatchToProps exposes the actions we want to call as props
 * @param state
 * @returns {}
 */
const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientLogo);
